import React from "react";

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>Fuel Your Passion. Feel the Speed.</h1>

        <div className="hero-buttons">
          <a href="/#findUs" className="hero-btn primary">
            Find a Store
          </a>

          <a href="/#deals" className="hero-btn secondary">
            Shop Online
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
